import type { AuthenticationStatus } from '@/features/user/types/authenticationStatus'
import type { User } from '@/features/user/types/user'

export function getAuthenticationStatusInLowerCase(user: User) {
  return user?.authenticationStatus?.toLowerCase() as Lowercase<AuthenticationStatus>
}
